import { useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import {
  FaBars,
  FaFire,
  FaHeart,
  FaClock,
  FaRegCommentDots,
  FaBell,
} from "react-icons/fa";
import MenuDrawer from "./MenuDrawer";
import { useSelector } from "react-redux";
import Notifications from "./Notifications";

function Header({ onOpenLogin, onOpenSignUp }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openNotifications, setOpenNotifications] = useState(false);

  const user = useSelector((state) => state.auth.user);
  const storedUser = localStorage.getItem("user");
  const navigate = useNavigate();

  const notificationCount = useSelector((state) => state.notification.notificationCount);
  const totalUnread = useSelector((state) => state.message.totalUnread);

  const OnAddCashClicked = () => {
    navigate("/payment");
  };

  return (
    <>
      <header className="fixed top-0 left-0 w-full z-50 w-full bg-black text-white px-6 py-4 flex items-center justify-between shadow-md">
        {/* LEFT - Logo + Menu */}
        <div className="flex items-center gap-4">
          <button className="text-2xl" onClick={() => setDrawerOpen(true)}>
            <FaBars />
          </button>

          <button
            className="text-2xl items-center flex"
            onClick={() => setDrawerOpen(true)}
          >
            <img src="./images/logo.png" alt="Logo" className="h-10 w-auto" />
            <span className="hidden md:inline text-3xl font-extrabold text-red-500">
              RED
            </span>
          </button>
        </div>

        {/* MIDDLE MENU */}
        <nav className="hidden md:flex items-center gap-10 absolute left-1/2 -translate-x-1/2">

          {
            <NavLink
              to="/explore"
              className={({ isActive }) =>
                `flex flex-col items-center transition ${isActive ? "text-red-500" : "text-white"
                }`
              }
            >
              <FaFire className="text-xl" />
              <span className="text-sm font-semibold">Explore</span>
            </NavLink>
          }

          <NavLink
            to="/followings"
            className={({ isActive }) =>
              `flex flex-col items-center transition ${isActive ? "text-red-500" : "text-white"
              }`
            }
          >
            <FaHeart className="text-xl" />
            <span className="text-sm">Followings</span>
          </NavLink>

          <NavLink
            to="/history"
            className={({ isActive }) =>
              `flex flex-col items-center transition ${isActive ? "text-red-500" : "text-white"
              }`
            }
          >
            <FaClock className="text-xl" />
            <span className="text-sm">History</span>
          </NavLink>

          <NavLink
            to="/messages"
            className={({ isActive }) =>
              `relative flex flex-col items-center transition ${isActive ? "text-red-500" : "text-white"
              }`
            }
          >
            {/* Icon with badge */}
            <div className="relative">
              <FaRegCommentDots className="text-xl" />

              {totalUnread > 0 && (
                <span className="absolute -top-2 -right-3 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[11px] font-bold flex items-center justify-center">
                  {totalUnread > 9 ? "9+" : totalUnread}
                </span>
              )}
            </div>

            <span className="text-sm">Messages</span>
          </NavLink>
        </nav>

        {/* RIGHT BUTTONS */}
        {!storedUser ? (
          <div className="flex items-center gap-4">
            <button
              onClick={onOpenLogin}
              className="px-6 py-2 border border-white rounded-full text-white hover:bg-white hover:text-black transition"
            >
              Log In
            </button>

            {/* OPEN MODAL — not navigate */}
            <button
              onClick={onOpenSignUp}
              className="px-6 py-2 bg-red-500 rounded-full text-white font-semibold"
            >
              Sign Up
            </button>
          </div>
        ) : (
          <div className="flex items-center gap-4">
            {/* Coin + Buy capsule */}
            {
              user?.role === "user" && user?.gender === 1 &&
              <div className="flex items-center bg-black border border-yellow-500 rounded-full overflow-hidden">
                {/* Left side: Coin + Count */}
                <div className="flex items-center gap-1 px-4 py-2 bg-black">
                  <img src="./images/goldcoin.png" alt="coin" className="w-6 h-6 rounded-full object-cover" />
                  <span className="text-white font-semibold">
                    {user?.walletBalance?.toFixed(2)}
                  </span>
                </div>

                {/* Right side: Buy Button */}
                <button
                  onClick={OnAddCashClicked}
                  className="bg-yellow-500 hover:bg-yellow-400 text-black px-5 py-2 font-semibold rounded-full transition"
                >
                  Buy
                </button>
              </div>
            }

            {/* Notification Bell */}
            <button
              onClick={(e) => {
                e.stopPropagation();
                setOpenNotifications(true);
              }}
              className="relative w-11 h-11 rounded-full bg-black border border-gray-700 flex items-center justify-center hover:bg-gray-900"
            >
              {/* 🔔 Bell perfectly centered */}
              <FaBell size={20} className="text-white" />

              {/* 🔴 Notification count (top-right corner) */}
              {notificationCount > 0 && (
                <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[11px] font-bold flex items-center justify-center leading-none">
                  {notificationCount > 9 ? "9+" : notificationCount}
                </span>
              )}
            </button>
          </div>
        )}
      </header>

      {/* DRAWER COMPONENT */}
      <MenuDrawer
        isOpen={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        onOpenLogin={onOpenLogin}
        onOpenSignUp={onOpenSignUp}
      />
      {/* ✅ NOTIFICATIONS PANEL */}
      <Notifications
        open={openNotifications}
        onClose={() => setOpenNotifications(false)}
      />
    </>
  );
}

export default Header;
